var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "ui-images": "static-2.1085"
    },
    "depPathPrefixes": {
      "ui-images": "/ui-images/static-2.1085"
    },
    "bundlingPackage": "InpageEditorUI",
    "bundlingPackageVersion": "static-1.84916",
    "project": "ui-images",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};